// extracted by mini-css-extract-plugin
export var scrollArea = "_pg-0";